export const EVENT_COLORS = [
  '#92A8F9',
  '#3f50b5',
  '#d40001',
  '#e67b73',
  '#f4511e',
  '#f5bf25',
  '#32b579',
  '#0a8043',
  '#14B3BD'
];

export const DAY_NUMBERS = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
};
